import { call, put, takeLatest } from 'redux-saga/effects'
import axiosApi from '../../views/client/axiosClient'
import { handleRequest } from '../../lib/common'
import {Constants, setData2, setLoading2} from './actions'

function* getData2(formData) {
  try {
    const request = axiosApi().post(
      Constants.GET_DATA_2_API,
      formData.payload
    )
    yield put(setLoading2(true))
    
    const response = yield call(handleRequest, request)
    if (!response.data) {
      return
    }
    const data = JSON.parse(response.data)
    if (data.dataChart) {
      yield put(setData2(data.dataChart))
    }
  } catch (error) {
    console.log(error)
  } finally {
    yield put(setLoading2(false))
  }
}

function* chartWatcher() {
  yield [
    takeLatest(Constants.GET_DATA_2, getData2)
  ]
}

export default chartWatcher


// WEBPACK FOOTER //
// ./src/components/Chart2/sagas.js